import { render, staticRenderFns } from "./courier-detail-shift.vue?vue&type=template&id=109b1fe9&scoped=true&"
import script from "./courier-detail-shift.js?vue&type=script&lang=js&"
export * from "./courier-detail-shift.js?vue&type=script&lang=js&"
import style0 from "./courier-detail-shift.scss?vue&type=style&index=0&id=109b1fe9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109b1fe9",
  null
  
)

export default component.exports